<template>
    <label v-if="$slots.default" class="cbox-wrapper flex self-center content-center flex-row-reverse items-start font-bold">
        <span class="ml-2"><slot/></span>
        <input type="checkbox" :id="id || 'no-id'" :name="name || 'no-name'" v-model="current_value" @change="$emit('input', current_value)">
        <span class="checkmark"/>
    </label>
</template>
<script>
export default {
    props: ['value', 'id', 'name'],
    data() {
        return {
            current_value: this.value,
        }
    },
    watch: {
        // current_value(cur_val) {
        //     this.$emit('input', cur_val);
        // }
    }
}
</script>
<style lang="scss" scoped>
    .cbox-wrapper {
//   display: block;
  position: relative;
//   padding-left: 35px;
//   margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  min-width: 25px;
  min-height: 25px;
}

/* Hide the browser's default checkbox */
.cbox-wrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: relative;
  display: inline-block;
  border-radius: 3px;
//   top: 0;
//   left: 0;
  height: 25px;
  width: 25px;
  min-height: 25px;
  min-width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.cbox-wrapper:hover input ~ .checkmark {
    background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.cbox-wrapper input:checked ~ .checkmark,
.cbox-wrapper.checked input ~ .checkmark {
    @apply bg-orange;
//   background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.cbox-wrapper input:checked ~ .checkmark:after,
.cbox-wrapper.checked input ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.cbox-wrapper .checkmark:after {
  left: 9px;
  top: 3px;
  width: 8px;
  height: 16px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

label {
    line-height: 24px;
    padding-top: 4px;
}
</style>